import { render } from "./landingKhaneNarm.vue?vue&type=template&id=049d36c6"
import script from "./landingKhaneNarm.vue?vue&type=script&lang=js"
export * from "./landingKhaneNarm.vue?vue&type=script&lang=js"

import "./landingKhaneNarm.vue?vue&type=style&index=0&id=049d36c6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__